import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { preferencesApi } from '../api/preferences';

// Keep server-generated notifications in the settings language; no polling.
export default function LocalizationPreferenceSync() {
  const { currentUserId, loading } = useAuth();
  const { language } = useLanguage();
  useEffect(() => {
    if (loading || !currentUserId) return undefined;
    const timer = setTimeout(() => {
      preferencesApi.updateLocalization({
        language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
      }).catch(() => {
        // In-app text still follows settings. Retry only on the next settings/session change.
      });
    }, 200);
    return () => clearTimeout(timer);
  }, [currentUserId, loading, language]);
  return null;
}
